/**
 * <show-more-collapse> — a "Show more / Show less" toggle for a section.
 *
 * The section renders everything, marks what should start hidden with
 * `hidden` + `data-show-more-extra`, and puts a button with
 * `data-show-more-toggle` (plus data-more-label / data-less-label) inside
 * this element. Used by sections/product-faq-v2.liquid (groups or questions
 * past the "Show at first" count) and sections/review-summary.liquid (the
 * cards after Fit Feedback and What Customers Say).
 *
 * Loaded as script[src] from each section so the PJAX layer re-executes it
 * on soft navigations (inline scripts in swapped-in sections do not run).
 */

if (!customElements.get('show-more-collapse')) {
  class ShowMoreCollapse extends HTMLElement {
    connectedCallback() {
      if (this.bound) return;
      this.bound = true;
      this.button = this.querySelector('[data-show-more-toggle]');
      this.extras = Array.from(this.querySelectorAll('[data-show-more-extra]'));
      if (!this.button || this.extras.length === 0) {
        if (this.button) this.button.hidden = true;
        return;
      }
      this.expanded = false;
      this.button.addEventListener('click', () => this.toggle());
    }

    toggle() {
      this.expanded = !this.expanded;
      this.extras.forEach((el) => { el.hidden = !this.expanded; });
      this.button.textContent = this.expanded
        ? (this.button.dataset.lessLabel || 'Show less')
        : (this.button.dataset.moreLabel || 'Show more');
      this.button.setAttribute('aria-expanded', this.expanded ? 'true' : 'false');
      if (!this.expanded) {
        // Collapsing can leave the viewport far below the list; bring the
        // list back into view rather than stranding the reader.
        const top = this.getBoundingClientRect().top;
        if (top < 0) this.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    }
  }

  customElements.define('show-more-collapse', ShowMoreCollapse);
}
